import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";
import Modal from 'react-modal';

import { updateProfilePicture, /*getMemberProfile,*/ getTopProfile } from "../../store/ducks/profile/actions";
//Icons
import { Icon } from "@iconify/react";

const maleIcon = [
  { name: "male-1.jpg", checked: true, src: "data:image/jpeg;base64,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" },
  { name: "male-2.jpg", checked: false, src: "" },
  { name: "male-3.jpg", checked: false, src: "" },
  { name: "male-4.jpg", checked: false, src: "" },
  { name: "male-5.jpg", checked: false, src: "" },
  { name: "male-6.jpg", checked: false, src: "" },
  { name: "male-7.jpg", checked: false, src: "" },
  { name: "male-8.jpg", checked: false, src: "" },
];
const femaleIcon = [
  { name: "female-1.jpg", checked: true, src: "data:image/jpeg;base64,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" },
  { name: "female-2.jpg", checked: false, src: "" },
  { name: "female-3.jpg", checked: false, src: "" },
  { name: "female-4.jpg", checked: false, src: "" },
  { name: "female-5.jpg", checked: false, src: "" },
  { name: "female-6.jpg", checked: false, src: "" },
  { name: "female-7.jpg", checked: false, src: "" },
  { name: "female-8.jpg", checked: false, src: "" },
];
export class SelectProfileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadImg: "",
      maleIcon: maleIcon,
      femaleIcon: femaleIcon,
      openAblum: false,
      gender: "male",
      userId: this.props.currentUser.data.id
        ? this.props.currentUser.data.id
        : "",
      uplodedImg: {}
    };
  }

  componentDidMount() {
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.update_profile_picture_result !== this.props.update_profile_picture_result) {
      if (nextProps.update_profile_picture_result.responseCode === 200) {
        const { t } = this.props;
        Swal.close();
        this.setState({ openAblum: false, uploadedImg: '' });
        this.props.closeProfileModal();

        Swal.fire({
          title: t("global.success"),
          text: t("global.record-updated"),
          icon: "success",
          confirmButtonText: t("global.ok"),
        }).then((result) => {
          if (result.isConfirmed) {
            // this.props.getMemberProfile();
            window.location.reload();
          }
        });
      } else if (nextProps.update_profile_picture_result.responseCode === 422) {
        this.setState({
          touched: true,
          // error_message: nextProps.memberProfileUpdateResult.message,
          errorMsg: (nextProps.update_profile_picture_result.message.input_error || []),
          formError: true,
          openAblum: false
        });
        Swal.close();
      } else {
        return false;
      }
    }

    return true;
  }


  changeGender = (g) => {
    this.setState({
      gender: g,
    });
  };

  changeMaleIcon = (e, index) => {
    let newMaleIcon = [...this.state.maleIcon];
    newMaleIcon[index].checked = true;

    for (let i = 0; i < newMaleIcon.length; i++) {
      if (i === index) {
        newMaleIcon[i].checked = true;
        newMaleIcon[i].src = e.target.src;
      } else {
        newMaleIcon[i].checked = false;
        newMaleIcon[i].src = "";
      }
    }

    this.setState({
      maleIcon: newMaleIcon,
    });
  };

  changeFemaleIcon = (e, index) => {
    let newFemaleIcon = [...this.state.femaleIcon];
    newFemaleIcon[index].checked = true;

    for (let i = 0; i < newFemaleIcon.length; i++) {
      if (i === index) {
        newFemaleIcon[i].checked = true;
        newFemaleIcon[i].src = e.target.src;
      } else {
        newFemaleIcon[i].checked = false;
        newFemaleIcon[i].src = "";
      }
    }

    this.setState({
      femaleIcon: newFemaleIcon,
    });
  };

  uploadProfileImage = (event) => {
    const that = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      that.setState({
        uploadImg: URL.createObjectURL(file),
        uploadedImg: file,
      });
    };
  };

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  onUpdateProfilePictureHandler = (e) => {
    e.preventDefault();
    const { t } = this.props;

    Swal.fire({
      title: t("global.confirmation"),
      text: t("profile.proceed-to-change-profile-image") + "?",
      icon: "warning",
      confirmButtonText: t("global.confirm"),
      showDenyButton: true,
      denyButtonText: t("global.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });


        let data = {};

        if (this.state.gender === "male" && this.state.uploadImg === "") {
          let newMaleIcon = [...this.state.maleIcon];
          for (let i = 0; i < newMaleIcon.length; i++) {
            if (newMaleIcon[i].checked === true) {
              data.profile_image = newMaleIcon[i].src;
            }
          }
        } else if (this.state.uploadImg === "") {
          let newFemaleIcon = [...this.state.femaleIcon];
          for (let i = 0; i < newFemaleIcon.length; i++) {
            if (newFemaleIcon[i].checked === true) {
              data.profile_image = newFemaleIcon[i].src;
            }
          }
        }

        else if (this.state.uploadedImg !== "") {
          data = new FormData();
          data.append('upload_profile_image', this.state.uploadedImg);
          data.append('member_id', this.state.userId);
        }

        data.member_id = this.state.userId;

        this.props.updateProfilePicture(data);
      }
    })
  }
  
  render() {
    const { t } = this.props;
    const img = this.imageImport(
      require.context(
        "../../assets/images/profile/",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    const profile = this.imageImport(
      require.context(
        "../../assets/images/profile/profile-icons",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    const icon = this.imageImport(
      require.context("../../assets/images/icons/", false, /\.(png|jpe?g|svg|webp)$/)
    );

    let topProfileData = null;
    if (!this.state.loading) {
      topProfileData = (this.props.topProfileData && this.props.topProfileData.data);
    }

    return (
      <Modal
        isOpen={this.props.openProfileModal}
        closeTimeoutMS={500}
        portalClassName={`global-modal`}
        className="modal modal-dialog modal-dialog-centered modal-pd"
        ariaHideApp={false}
        onRequestClose={this.props.toggleProfileModal}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-dark" id="selectCountryLabel">
              {t("profile.edit-profile-icon")}
            </h5>
            <Icon
              type="button"
              className="btn-close"
              icon="mdi:close"
              onClick={()=>{this.props.toggleProfileModal(); this.setState({ openAblum: false });}}
              // onClick={() => {
              //   this.setState({ openAblum: false })
              // }}
            />
          </div>
          <div className="modal-body pf-select-container">
            {this.state.openAblum ? (
              <div className="upload-profile-container gap-3 w-75">
                {this.state.uploadImg ? (
                  <img
                    className="uploaded-img"
                    src={this.state.uploadImg}
                    alt="uploaded"
                  />
                ) : (
                  <img
                    className="uploaded-img"
                    src={img["upload-img.jpg"]}
                    alt="uploaded"
                  />
                )}
                <label
                  className="upload-btn"

                  htmlFor="formId"
                >
                  <input name="" type="file" id="formId" hidden accept="image/png, image/gif, image/jpeg" onChange={(e) => this.uploadProfileImage(e)} />
                  {t("profile.upload-image")}
                </label>
                <p>{t("profile.file-size")}: {t("global.maximum")} 1 MB • {t("profile.file-extension")}: .JPEG, .PNG</p>
                <div className="d-flex justify-content-between w-100">
                  <button
                    className="btn btn-gray"
                    onClick={() => this.setState({ openAblum: false })}
                  >
                    {t("global.back")}
                  </button>
                  <button className="btn btn-gradient-blue" onClick={this.onUpdateProfilePictureHandler}>{t("global.save")}</button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-4 d-flex flex-column align-items-center">
                  <img
                    className="profile-img"
                    src={(topProfileData && topProfileData.topProfile.profile_picture) || profile["male-5.jpg"]}
                    alt="profile-img"
                  />
                  <div className="pf-gender">
                    <button
                      className={`btn ${this.state.gender === "male"
                          ? "btn-gradient-blue"
                          : "btn-white"
                        }`}
                      onClick={() => this.changeGender("male")}
                    >
                      <Icon icon="mdi:gender-male" />
                      <span>M</span>
                    </button>
                    <button
                      className={`btn ${this.state.gender === "female"
                          ? "btn-gradient-blue"
                          : "btn-white"
                        }`}
                      onClick={() => this.changeGender("female")}
                    >
                      <Icon
                        className="female-icon"
                        icon="mdi:gender-female"
                      />
                      <span>F</span>
                    </button>
                  </div>
                </div>
                <div className="col-8">
                  <div className="pf-pic">
                    <ul className="row g-2 mb-3">
                      {this.state.gender === "male"
                        ? this.state.maleIcon &&
                        this.state.maleIcon.map((item, index) => (
                          <li
                            className="col-3 position-relative"
                            key={index}
                          >
                            <img
                              className={`profile-icon ${item.checked ? "selected" : ""
                                }`}
                              src={profile[item.name]}
                              alt={item.name}
                              onClick={(e) => this.changeMaleIcon(e, index)}
                            />
                            {item.checked && (
                              <img
                                className="profile-checked"
                                src={icon["check-icon.webp"]}
                                alt="checked"
                              />
                            )}
                          </li>
                        ))
                        : this.state.femaleIcon &&
                        this.state.femaleIcon.map((item, index) => (
                          <li
                            className="col-3 position-relative"
                            key={index}
                          >
                            <img
                              className={`profile-icon ${item.checked ? "selected" : ""
                                }`}
                              src={profile[item.name]}
                              alt={item.name}
                              onClick={(e) => this.changeFemaleIcon(e, index)}
                            />
                            {item.checked && (
                              <img
                                className="profile-checked"
                                src={icon["check-icon.webp"]}
                                alt="checked"
                              />
                            )}
                          </li>
                        ))}
                    </ul>
                    <span className="line">or</span>
                    <div
                      className="ablum-select my-3"
                      onClick={() => this.setState({ openAblum: true })}
                    >
                      <img src={icon["ablum-icon.svg"]} alt="ablum" />
                      <span>{t("global.photo-album")}</span>
                    </div>
                    <button className="btn btn-gradient-blue" onClick={this.onUpdateProfilePictureHandler}>{t("global.save")}</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}


const mapStateToProps = (state) => {
  const { profile } = state;
  return {
    update_profile_picture_result: profile.update_profile_picture_result,
    currentUser: state.currentUser,
    topProfileData: state.profile.top_profile_data
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProfilePicture: (data) => dispatch(updateProfilePicture(data)),
    getTopProfile: () => dispatch(getTopProfile())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SelectProfileModal));
